export default __webpack_public_path__ + "static/1-2af3740a9b8fc0cc1aed2e68a89a06c7.gif";